// src/components/Dashboard.js
import React, { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import Map from "./Map";
import RightSidebar from "./RightSidebar";
import Table from "./Table";
import TopFilters from "./TopFilters";
import "./Dashboard.css";
import { ButtonContainer } from './Button';
/* ✅ SINGLE SOURCE OF TRUTH FOR FILTER KEYS */
const defaultFilters = {
  heatmapType: "Application Opened",

  fromMonth: "",
  toMonth: "",

  regionState: [],
  regionDistrict: [],

  clientProjectName: [],
  clientProjectType: [],

  serviceType: [],
  schemeName: [],

  tgGender: [],
  tgPWD: [],
  tgRationCard: [],
  tgOccupation: [],

  tgAge: [],
  tgIncome: [],
  thematicArea: []
};

const Dashboard = () => {
  const [filters, setFilters] = useState(defaultFilters);
  const [topSchemes, setTopSchemes] = useState([]);
  const [lastUpdated, setLastUpdated] = useState(null);

  /* ---------------- FILTER HANDLERS ---------------- */
  const handleFilterChange = (key, value) => {
    setFilters(prev => ({ ...prev, [key]: value }));
  };

  const handleResetFilters = () => {
    setFilters(defaultFilters);
  };

  /* ---------------- LAST UPDATED ---------------- */
  useEffect(() => {
    fetch("/db2_date&time.json")
      .then(res => res.json())
      .then(data =>
        setLastUpdated(new Date(data.updatedAt).toLocaleString())
      )
      .catch(console.error);
  }, []);

  return (
    <>
    <ButtonContainer />
      <TopFilters
  filters={filters}
  onApply={(newFilters) => setFilters(newFilters)}
  onReset={handleResetFilters}
/>


      <div className="dashboard">
        <Sidebar />

        <div className="main-content">
          
          <Map filters={filters} />
        </div>

        <RightSidebar
          
        />
      </div>

      <div className="table-section">
        <Table filters={filters} />
      </div>
    </>
  );
};

export default Dashboard;
